// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-table[data-v-16087958] {\n  padding-left: 50px;\n}\n.list-wrap[data-v-16087958] {\n  border-bottom: 1px solid #f1f1f1;\n  margin-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
